<div class="dialog">
  <ng-lottie [options]="{path: '/assets/animations/product-icons/basic.json'}"></ng-lottie>
  <h1>Upgrade Now</h1>
  <p>You’ve reached your <b>{{state.plan.limits.galleryLimit}} Gallery Limit</b>, upgrade your plan to keep the flow
    going.</p>

  <button appButton name="confirm" location="gallery-limit-reached-dialog" color="primary" size="3" height="4" spacing="full"
    (click)="continue()">Choose Plan</button>
  <button appButton name="cancel" location="gallery-limit-reached-dialog" color="simple-gray" (click)="close(false)" size="3" height="1"
    weight="bold" class="sub-cta" [center]="true">Maybe Later</button>

</div>
